import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderRequestDataImplEncoder } from "../../encoder/OrderRequestDataImplEncoder";

import * as CubiqTS from "../../index";
import { OrderRequestData } from "../OrderRequestData";
import { v4 as uuid } from "uuid";

export class OrderRequestDataImpl extends ConcreteEncodable implements OrderRequestData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.OrderRequestDataImpl";

  /*FID=1*/
  accountCode: string;
  /*FID=2*/
  activationDetailUtc: CubiqTS.moment.Moment;
  /*FID=3*/
  base: string;
  /*FID=4*/
  clientCode: string;
  /*FID=5*/
  comment: string;
  /*FID=6*/
  comment2: string;
  /*FID=7*/
  expiryDetailUtc: CubiqTS.moment.Moment;
  /*FID=8*/
  externalClientReference: string;
  /*FID=9*/
  fillSupport: CubiqTS.FillSupport;
  /*FID=10*/
  fillTypeRestriction: CubiqTS.RequestorFillTypeRestriction;
  /*FID=11*/
  fixedAmount: string;
  /*FID=12*/
  fixedCcy: string;
  /*FID=13*/
  fixingDate: CubiqTS.StandardDate;
  /*FID=14*/
  fixingSource: string;
  /*FID=15*/
  forwardTrackingType: CubiqTS.RequestTrackingType;
  /*FID=16*/
  markup: string;
  /*FID=17*/
  nonBase: string;
  /*FID=18*/
  orderId: string;
  /*FID=19*/
  orderType: CubiqTS.OrderType;
  /*FID=20*/
  product: CubiqTS.Product;
  /*FID=21*/
  requestOrderType: CubiqTS.RequestOrderType;
  /*FID=22*/
  requestRate: string;
  /*FID=23*/
  slippage: string;
  /*FID=24*/
  stpHold: boolean;
  /*FID=25*/
  strategyParameters: Array<CubiqTS.StrategyParameterImpl>;
  /*FID=26*/
  tenor: CubiqTS.Tenor;
  /*FID=27*/
  traderGroup: string;
  /*FID=28*/
  tradingChannel: string;
  /*FID=29*/
  tslDistancePips: string;
  /*FID=30*/
  tslStartRate: string;
  /*FID=31*/
  valueDate: CubiqTS.StandardDate;
  /*FID=32*/
  isPrivateOrder: boolean;
  /*FID=33*/
  clientIntent: CubiqTS.OrderIntent;
  /*FID=34*/
  childRelationships: Array<CubiqTS.LinkedRelationshipImpl>;
  /*FID=35*/
  sibling: CubiqTS.LinkedRelationshipImpl;
  /*FID=36*/
  useDefaultClientDataFg: boolean;
  /*FID=37*/
  clientContacts: Array<CubiqTS.Long>;
  /*FID=38*/
  activationDetails: CubiqTS.ActivationDetailsImpl;
  /*FID=39*/
  expiryDetails: CubiqTS.ExpiryDetailsImpl;
  /*FID=40*/
  customValues: Array<CubiqTS.CustomValue> | null = null;
  /*FID=41*/
  markupType: CubiqTS.MarkUpType;
  /*FID=42*/
  fixingCode: string;
  /*FIX=43*/
  fixingTime: CubiqTS.StandardTime;
  /*FID=44*/
  algoProfileId: string;
  /*FID=45*/
  passthroughParameters: Array<CubiqTS.StrategyParameterImpl>;
  /*FID=46*/
  stpAggregationEnabled: boolean;
  /*FID=47*/
  public algoStrategyName: string;
  /*FID=48*/
  oboClient: string;
  /*FID=49*/
  oboAccount: string;
  /*FID=50*/
  orderRef: string;
  /*FID=51*/
  autoForwardPricing: boolean;

  /*FID=100*/
  messageId: string;
  constructor() {
    super();
    this.encoder = OrderRequestDataImplEncoder.Instance;
    this.setEncodableType(OrderRequestDataImpl.enType);
    this.messageId = uuid();
  }

  public toString(): string {
    return (
      "OrderRequestDataImpl[" +
      "accountCode=" +
      this.accountCode +
      "activationDetailUtc=" +
      this.activationDetailUtc +
      "base=" +
      this.base +
      "clientCode=" +
      this.clientCode +
      "comment=" +
      this.comment +
      "comment2=" +
      this.comment2 +
      "expiryDetailUtc=" +
      this.expiryDetailUtc +
      "externalClientReference=" +
      this.externalClientReference +
      "fillSupport=" +
      this.fillSupport +
      "fillTypeRestriction=" +
      this.fillTypeRestriction +
      "fixedAmount=" +
      this.fixedAmount +
      "fixedCcy=" +
      this.fixedCcy +
      "fixingDate=" +
      this.fixingDate +
      "fixingSource=" +
      this.fixingSource +
      "forwardTrackingType=" +
      this.forwardTrackingType +
      "customValues=" +
      this.customValues +
      "markupType=" +
      this.markupType +
      "markup=" +
      this.markup +
      "nonBase=" +
      this.nonBase +
      "orderId=" +
      this.orderId +
      "orderType=" +
      this.orderType +
      "product=" +
      this.product +
      "requestOrderType=" +
      this.requestOrderType +
      "requestRate=" +
      this.requestRate +
      "slippage=" +
      this.slippage +
      "stpHold=" +
      this.stpHold +
      "autoForwardPricing=" +
      this.autoForwardPricing +
      "strategyParameters=" +
      this.strategyParameters +
      "tenor=" +
      this.tenor +
      "traderGroup=" +
      this.traderGroup +
      "tradingChannel=" +
      this.tradingChannel +
      "tslDistancePips=" +
      this.tslDistancePips +
      "tslStartRate=" +
      this.tslStartRate +
      "valueDate=" +
      this.valueDate +
      "isPrivateOrder=" +
      this.isPrivateOrder +
      "clientIntent=" +
      this.clientIntent +
      "childRelationships=" +
      this.childRelationships +
      "sibling=" +
      this.sibling +
      "algoProfileId=" +
      this.algoProfileId +
      "passthroughParameters=" +
      this.passthroughParameters +
      "stpAggregationEnabled=" +
      this.stpAggregationEnabled +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "orderRef=" +
      this.orderRef +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
